import { render, staticRenderFns } from "./CourseStudentsPage.vue?vue&type=template&id=48cceebe&scoped=true&"
import script from "./CourseStudentsPage.vue?vue&type=script&lang=js&"
export * from "./CourseStudentsPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseStudentsPage.vue?vue&type=style&index=0&id=48cceebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cceebe",
  null
  
)

export default component.exports